var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHamburgerMenuLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "20px",
    viewBox: "0 0 25 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home-(Hamburger-Menu)-Copy",
    transform: "translate(-24.000000, -21.000000)",
    stroke: "#4A5866",
    strokeWidth: 3.24
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(26.000000, 22.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 1,
    x2: 21,
    y2: 1,
    id: "Line"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 9,
    x2: 21,
    y2: 9,
    id: "Line-Copy"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 17,
    x2: 21,
    y2: 17,
    id: "Line-Copy-2"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgerMenuLight);
export default __webpack_public_path__ + "static/media/hamburger-menu-light.cc27df5309343636a89c6c61dca68db2.svg";
export { ForwardRef as ReactComponent };